import React from 'react'
import { FormattedMessage } from 'react-intl'
import { SoundProps } from '../../../types/sound'
import { Sound } from '../../components/app/media'


interface Props {
  medias: Array<SoundProps>
}

const SearchMedia = ({ medias }: Props) => (
  <div className="pb-3">
    {medias.length === 0 && (
      <div className="tx-center tx-w500 py-5">
        <FormattedMessage
          id="search.noresult"
          defaultMessage="We couldn’t find any sounds."
        />
      </div>
    )}
    {medias.map((media) => (
      <div key={media.id}>
        <Sound sound={media} />
      </div>
    ))}
  </div>
)

export default SearchMedia
